import { createMutation, createQuery } from '@/logic/libs';
import {
  CalculateMultipleVoucherResponse,
  SubmitVoucherRequest,
  SubmitVoucherResponse,
  VerifyVoucherResponse,
} from './models';

const baseUrl = 'orders/:orderId/voucher';
export const calculateBaseUrl = `${baseUrl}/calculate`;

export const useVerifyVoucher = createMutation<
  VerifyVoucherResponse,
  unknown,
  'orderId',
  {
    barCode: string;
  }
>({
  method: 'get',
  url: `${baseUrl}/verify`,
});

export const useSubmitVoucher = createMutation<
  SubmitVoucherResponse,
  SubmitVoucherRequest,
  'orderId'
>({
  method: 'post',
  url: `${baseUrl}`,
});

export const useDeleteVoucher = createMutation<
  SubmitVoucherResponse,
  unknown,
  'orderId',
  {
    barCode: string;
  }
>({
  method: 'delete',
  url: `${baseUrl}`,
});

export const useCalculateMultipleVoucher = createQuery<
  CalculateMultipleVoucherResponse,
  unknown,
  'orderId',
  {
    barCode: string;
    quantity: number;
  }
>({
  method: 'get',
  url: calculateBaseUrl,
});
